import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-stackholder-feedback',
  templateUrl: './iqac-stackholder-feedback.component.html',
  styleUrls: ['./iqac-stackholder-feedback.component.scss']
})
export class IqacStackholderFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
